
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FlyingSpan',
  data: () => ({
    flyin: false,
  }),
  props: {
    block: Boolean,
    left: Boolean,
    timeout: Number,
  },
  mounted() {
    const elem = this.$refs.span as HTMLSpanElement;
    const checkPos = () => {
      if (elem.getBoundingClientRect().top
        < document.documentElement.clientHeight) {
        setTimeout(() => { this.flyin = true; }, this.timeout);
      }
    };
    checkPos();
    window.addEventListener('scroll', checkPos);
  },
});
